<template>
  <section ref="receivers" class="receivers" :class="{receiverse__single: single}">
    <div class="receiver__container">
      <div class="receiver__top">
        <div class="receiver__title">
          {{ t('Receivers') }}
        </div>
        <div class="receiver__presentationId">
          Presentation ID {{presentationId}}
        </div>
      </div>
      <div class="receiver__bottom">
        <div class="receiver__item" v-for="item in receivers" :key="item.accountId">
          <div class="item__img">
            <svg v-if="!item.img || showImgPlaceholder" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28 0C12.5323 0 0 12.5323 0 28C0 43.4677 12.5323 56 28 56C43.4677 56 56 43.4677 56 28C56 12.5323 43.4677 0 28 0ZM28 10.8387C33.4871 10.8387 37.9355 15.2871 37.9355 20.7742C37.9355 26.2613 33.4871 30.7097 28 30.7097C22.5129 30.7097 18.0645 26.2613 18.0645 20.7742C18.0645 15.2871 22.5129 10.8387 28 10.8387ZM28 49.6774C21.3726 49.6774 15.4339 46.6742 11.4597 41.9774C13.5823 37.9806 17.7371 35.2258 22.5806 35.2258C22.8516 35.2258 23.1226 35.271 23.3823 35.35C24.85 35.8242 26.3855 36.129 28 36.129C29.6145 36.129 31.1613 35.8242 32.6177 35.35C32.8774 35.271 33.1484 35.2258 33.4194 35.2258C38.2629 35.2258 42.4177 37.9806 44.5403 41.9774C40.5661 46.6742 34.6274 49.6774 28 49.6774Z" fill="#EDECF2"/><path d="M37.9356 20.7739C37.9356 15.2868 33.4872 10.8384 28.0001 10.8384C22.513 10.8384 18.0646 15.2868 18.0646 20.7739C18.0646 26.261 22.513 30.7093 28.0001 30.7093C33.4872 30.7093 37.9356 26.261 37.9356 20.7739Z" fill="#C7C7CC"/><path d="M11.4594 41.9772C15.4336 46.674 21.3723 49.6772 27.9997 49.6772C34.6272 49.6772 40.5659 46.674 44.5401 41.9772C42.4175 37.9804 38.2626 35.2256 33.4191 35.2256C33.1481 35.2256 32.8772 35.2707 32.6175 35.3498C31.161 35.824 29.6143 36.1288 27.9997 36.1288C26.3852 36.1288 24.8497 35.824 23.382 35.3498C23.1223 35.2707 22.8514 35.2256 22.5804 35.2256C17.7368 35.2256 13.582 37.9804 11.4594 41.9772Z" fill="#C7C7CC"/><circle cx="28" cy="28" r="27.5" stroke="#BBBBBB"/></svg>
            <img v-else :src="item.img"  alt="Receiver Image" @error="showImgPlaceholder = true">
          </div>
          <div class="item__info">
            <div class="item__name">{{item.name}}</div>
            <div class="item__descr">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import { useI18n } from "vue-i18n";

  export default {
    props: ['receivers', 'single'],
    setup(){
      const { t } = useI18n();
      return { t };
    },
    data() {
      return {
        showImgPlaceholder: false
      }
    },
    computed: {
      ...mapState([
        'receiver',
        'presentationId'
      ]),
    }
  }
</script>

<style scoped lang="scss">
  .receivers{
    background-color: #FAFAFA;
    padding: 28px 0 12px;
    border-top: 1px solid #E5E5EA;
    margin-top: auto;

    &.receiverse__single{
      margin-top: 0;
      border-top: 0;
    }
  }

  .receiver__container{
    max-width: 635px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .receiver__top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999999;
    margin-bottom: 15px;
  }

  .receiver__title{
    font-size: 11px;
    line-height: 16px;
    text-transform: uppercase;
  }

  .receiver__presentationId{
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
  }

  .receiver__bottom{
    display: flex;
    flex-wrap: wrap;
  }

  .receiver__item{
    display: flex;
    width: 48%;
    margin-bottom: 20px;

    &:nth-child(odd){
      padding-right: 10px;
    }

    @media (min-width: 768px){
      width: 32.2%;

      &:nth-child(odd){
        padding-right: 0;
      }

      &:not(:nth-child(3n)){
        padding-right: 10px;
      }
    }

    .item__img{
      max-width: 34px;
      width: 100%;
      height: 34px;
      margin-right: 10px;

      img{
        border-radius: 50%;
        height: 34px;
        width: 100%;
        object-fit: cover;
      }

      svg {
        height: 34px;
        width: 100%;
        object-fit: cover;
      }
    }

    .item__info{
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .item__name{
      font-size: 12px;
      line-height: 16px;
      color: #333;
      margin-bottom: 2px;
    }

    .item__descr{
      font-size: 12px;
      line-height: 16px;
      color: #999;
    }
  }
</style>
